export default __webpack_public_path__ + "static/media/sopTrashIcon.76e0a200.svg";